import { render, staticRenderFns } from "./LeadsListItem.vue?vue&type=template&id=54e3fd10&scoped=true&"
import script from "./LeadsListItem.vue?vue&type=script&lang=js&"
export * from "./LeadsListItem.vue?vue&type=script&lang=js&"
import style0 from "./LeadsListItem.vue?vue&type=style&index=0&id=54e3fd10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e3fd10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54e3fd10')) {
      api.createRecord('54e3fd10', component.options)
    } else {
      api.reload('54e3fd10', component.options)
    }
    module.hot.accept("./LeadsListItem.vue?vue&type=template&id=54e3fd10&scoped=true&", function () {
      api.rerender('54e3fd10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/leads/LeadsListItem.vue"
export default component.exports